import { ErrorHandler } from '@angular/core';
export class ApmErrorHandler extends ErrorHandler {
  handleError(error) {
    ApmErrorHandler.apm.captureError(error.originalError || error);
    super.handleError(error);
  }

}
ApmErrorHandler.apm = void 0;